import Cookies from "js-cookie";
import toast from "react-hot-toast";
import axiosInstance from "../../../api/axios.instance";
import { definingPathForUser, definingTextOfMenuItem } from "../../../utils";

// The signed-in team member's menu: the same items on desktop (avatar menu)
// and on mobile (burger), each shown to the roles that use it.

export const ROLE_NAME = { admin: "Admin", researcher: "Researcher", "copyright manager": "Copyright manager", editor: "Editor", "output editor": "Output editor", "gallery editor": "Gallery editor" };
const ROLE_HOME = { admin: "/admin", researcher: "/researcher", "copyright manager": "/researcher", editor: "/publishing", "output editor": "/publishing", "gallery editor": "/galleries" };

// one person with two roles (researcher + admin …): switch without logging out
export const switchRole = async (role) => {
  try {
    const { data } = await axiosInstance.post("/auth/switchRole", { role });
    Cookies.set("vb-access-token", data.apiData.accessToken);
    Cookies.set("vb-refresh-token", data.apiData.refreshToken);
    window.location.assign(ROLE_HOME[role] || "/");
  } catch (err) {
    toast.error(err?.response?.data?.message || "Could not switch the role");
  }
};

/** [{ key, label, path, icon }] for this user, without the page they are on */
export const accountLinks = (user, pathname) => {
  if (!user) return [];
  const role = user.role || "";
  const home = definingPathForUser(user);
  return [
    home && { key: "home", label: definingTextOfMenuItem(user), path: home, icon: "user" },
    ["admin", "output editor"].includes(role) && { key: "publishing", label: "Publishing", path: "/publishing", icon: "video" },
    role === "admin" && { key: "galleries", label: "Galleries (MSN)", path: "/galleries", icon: "video" },
    ["admin", "editor", "output editor", "copyright manager"].includes(role) && { key: "researcher", label: "Researchers", path: "/researcher", icon: "users" },
    (role.toLowerCase().includes("admin") || role.toLowerCase().includes("copyright manager") || role === "output editor") && {
      key: "copyright",
      label: "Copyright requests",
      path: "/copyrightRequest",
      icon: "video",
    },
    ["admin", "output editor", "copyright manager"].includes(role) && { key: "whitelisting", label: "Whitelisting", path: "/whitelisting", icon: "shield" },
    role === "company" && { key: "adding", label: "Add panel", path: "/adding", icon: "video" },
    // the team: photo and contacts on the chat card (changes approved by an admin)
    ["admin", "researcher", "editor", "output editor", "copyright manager"].includes(role) && {
      key: "profile",
      label: "My profile",
      path: "/researcher?tab=profile",
      icon: "user",
    },
    // the gallery editor's profile is on their own page
    role === "gallery editor" && { key: "profile", label: "My profile", path: "/galleries?tab=profile", icon: "user" },
  ].filter((x) => {
    if (!x) return false;
    const search = window.location.search;
    if (`${pathname}${search}` === x.path) return false;
    // on "My profile" (?tab=profile) the home page stays in the menu: the way back
    return !(pathname === x.path && !/[?&]tab=profile/.test(search));
  });
};

export const otherRoles = (user) => (user?.roles || []).filter((r) => r !== user.role);
